import {
  RECEIVE_BANNERS,
  FETCH_BANNERS,
  SET_BANNERS_ERRORS,
  RECEIVE_BANNERS_CODES,
  FETCH_BANNERS_CODES,
} from '../constants/index';
import {
  data_fetch_api_resource,
} from '../utils/http_functions';

export function receiveBanners(bannerCode, bannerValue) {
  return {
    type: RECEIVE_BANNERS,
    payload: {bannerCode, bannerValue}
  }
}

export function setBannersErrors(bannerCode, bannerError) {
  return {
    type: SET_BANNERS_ERRORS,
    payload: {bannerCode, bannerError}
  }
}

export function receiveBannersCodes(bannerCode, bannersCodes) {
  return {
    type: RECEIVE_BANNERS_CODES,
    payload: {bannerCode, bannersCodes}
  }
}

export const fetchBanners = (bannerCode) => async (dispatch, getState) => {
  const { token } = getState().auth;
  dispatch({ 
    type: FETCH_BANNERS,
    payload: {bannerCode}
  });

  return data_fetch_api_resource(token, `banners/${bannerCode}`, 2)
    .then( response => {
      dispatch(receiveBanners(bannerCode, response.data?.banner));
    })
    .catch( reason => {
      console.debug('reason',reason)
      const bannerError = reason?.response?.data ?? reason?.message ?? 'unknown_error';
      dispatch(setBannersErrors(bannerCode, bannerError))
    })
}

export const fetchBannersCodes = (variableName) => async (dispatch, getState) => {
  const { token } = getState().auth;
  dispatch({ 
    type: FETCH_BANNERS_CODES,
    payload: {variableName}
  });

  return data_fetch_api_resource(token, `variable-conf-banner/${variableName}`, 2)
    .then( response => {
      dispatch(receiveBannersCodes(variableName, response.data?.bannersCodes));
    })
    .catch( reason => {
      console.debug('reason',reason)
      dispatch(setBannersErrors(variableName, reason))
    })
}